/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://o6f3qg32cneozpmoejwwgrwlv4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-2:94c9b2d9-b262-4222-80dd-b64927e4e6d8",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_dlsWwcGDg",
    "aws_user_pools_web_client_id": "27k8n8mboadbuf0c4ntfbdoquh",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ObjectAudit-qab",
            "region": "us-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "alucio-beacon-content194305-qab",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
